import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { FormatURI, HttpService } from '../app/utility/http-service';

/** An Enverus Accounts Service organization offered in the Add Client picker. */
export interface OrganizationOption {
  organizationId: string;
  name: string;
  /** Set when a WellChron client is already linked to this organization; it cannot be linked again. */
  linkedClientId?: string | null;
  linkedClientName?: string | null;
}

export interface AddClientRequest {
  displayName: string;
  domain?: string | null;
  salesforceId?: string | null;
  organizationId?: string | null;
  createOrganization: boolean;
}

export interface LinkOrganizationRequest {
  clientId: string;
  domain?: string | null;
  salesforceId?: string | null;
  organizationId?: string | null;
  createOrganization: boolean;
}

export interface ClientOnboardingResult {
  clientId: string;
  organizationId: string;
  organizationCreated: boolean;
  /** Set when the client was saved and linked but its WellChron roles could not be added. */
  warning?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ClientOrganizationsService {
  private readonly base = 'ClientOrganizations';

  constructor(private http: HttpService, private client: HttpClient) {}

  /**
   * Type-ahead search. Goes straight to HttpClient rather than HttpService so each keystroke does not
   * flash the loading overlay or pop an error dialog; the dialog shows failures inline instead.
   */
  search(text: string): Observable<OrganizationOption[]> {
    return this.client
      .get<any>(FormatURI(`${this.base}/Search?text=${encodeURIComponent(text)}`))
      .pipe(map(x => {
        if (x && 'errorIndicator' in x) throw new Error(x.message);
        return (x ?? []) as OrganizationOption[];
      }));
  }

  addClient(request: AddClientRequest, onSuccess: (r: ClientOnboardingResult) => void, onError: () => void): void {
    this.http.postReturn(`${this.base}/AddClient`, onSuccess, undefined, request, onError);
  }

  linkOrganization(request: LinkOrganizationRequest, onSuccess: (r: ClientOnboardingResult) => void, onError: () => void): void {
    this.http.postReturn(`${this.base}/LinkOrganization`, onSuccess, undefined, request, onError);
  }
}
